"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MEDIA_REMOTE_KEY_CODE;
(function (MEDIA_REMOTE_KEY_CODE) {
    MEDIA_REMOTE_KEY_CODE[MEDIA_REMOTE_KEY_CODE["PLAY"] = 32] = "PLAY";
    MEDIA_REMOTE_KEY_CODE[MEDIA_REMOTE_KEY_CODE["NEXT"] = 120] = "NEXT";
    MEDIA_REMOTE_KEY_CODE[MEDIA_REMOTE_KEY_CODE["PREV"] = 118] = "PREV";
    MEDIA_REMOTE_KEY_CODE[MEDIA_REMOTE_KEY_CODE["PAUSE"] = 80] = "PAUSE";
    MEDIA_REMOTE_KEY_CODE[MEDIA_REMOTE_KEY_CODE["STOP"] = 83] = "STOP";
    MEDIA_REMOTE_KEY_CODE[MEDIA_REMOTE_KEY_CODE["FF"] = 127] = "FF";
    MEDIA_REMOTE_KEY_CODE[MEDIA_REMOTE_KEY_CODE["RW"] = 128] = "RW";
})(MEDIA_REMOTE_KEY_CODE = exports.MEDIA_REMOTE_KEY_CODE || (exports.MEDIA_REMOTE_KEY_CODE = {}));
var UWPMediaRemoteService = (function () {
    function UWPMediaRemoteService(winRtBridge) {
        this.winRtBridge = winRtBridge;
        this.onKeyDownCallbacks = [];
        this.onKeyUpCallbacks = [];
        this.systemMediaControls = this.winRtBridge.getMediaRemoteControls();
        this.enableSystemMediaTransportControls();
    }
    UWPMediaRemoteService.getInstance = function (winRtBridge) {
        if (!UWPMediaRemoteService.instance) {
            UWPMediaRemoteService.instance = new UWPMediaRemoteService(winRtBridge);
        }
        return UWPMediaRemoteService.instance;
    };
    UWPMediaRemoteService.prototype.onKeyDown = function (callback) {
        this.onKeyDownCallbacks.push(callback);
    };
    UWPMediaRemoteService.prototype.onKeyUp = function (callback) {
        this.onKeyUpCallbacks.push(callback);
    };
    UWPMediaRemoteService.prototype.setStatusPlaying = function () {
        this.systemMediaControls.playbackStatus = this.winRtBridge.getMediaPlaybackStatus().playing;
    };
    UWPMediaRemoteService.prototype.setStatusPaused = function () {
        this.systemMediaControls.playbackStatus = this.winRtBridge.getMediaPlaybackStatus().paused;
    };
    UWPMediaRemoteService.prototype.setStatusStopped = function () {
        this.systemMediaControls.playbackStatus = this.winRtBridge.getMediaPlaybackStatus().stopped;
    };
    UWPMediaRemoteService.prototype.enableSystemMediaTransportControls = function () {
        this.systemMediaControls.isEnabled = true;
        this.systemMediaControls.onbuttonpressed = this.systemMediaControlsButtonPressed.bind(this);
        this.systemMediaControls.isPlayEnabled = true;
        this.systemMediaControls.isPauseEnabled = true;
        this.systemMediaControls.isStopEnabled = true;
        this.systemMediaControls.isNextEnabled = true;
        this.systemMediaControls.isFastForwardEnabled = true;
        this.systemMediaControls.isPreviousEnabled = true;
        this.systemMediaControls.isRewindEnabled = true;
        this.systemMediaControls.playbackStatus = this.winRtBridge.getMediaPlaybackStatus().stopped;
    };
    UWPMediaRemoteService.prototype.systemMediaControlsButtonPressed = function (event) {
        var mediaButton = this.winRtBridge.getMediaRemoteButtons();
        switch (event.button) {
            case mediaButton.play:
                this.sendKey(MEDIA_REMOTE_KEY_CODE.PLAY);
                break;
            case mediaButton.pause:
                this.sendKey(MEDIA_REMOTE_KEY_CODE.PAUSE);
                break;
            case mediaButton.stop:
                this.sendKey(MEDIA_REMOTE_KEY_CODE.STOP);
                break;
            case mediaButton.next:
                this.sendKey(MEDIA_REMOTE_KEY_CODE.NEXT);
                break;
            case mediaButton.fastForward:
                this.sendKey(MEDIA_REMOTE_KEY_CODE.FF);
                break;
            case mediaButton.previous:
                this.sendKey(MEDIA_REMOTE_KEY_CODE.PREV);
                break;
            case mediaButton.rewind:
                this.sendKey(MEDIA_REMOTE_KEY_CODE.RW);
                break;
            default:
                break;
        }
    };
    UWPMediaRemoteService.prototype.sendKey = function (key) {
        this.onKeyDownCallbacks.forEach(function (cb) { return cb(key); });
        this.onKeyUpCallbacks.forEach(function (cb) { return cb(key); });
    };
    return UWPMediaRemoteService;
}());
exports.UWPMediaRemoteService = UWPMediaRemoteService;
